import { useAuth } from "@/context/AuthContext";
import { Sparkles } from "lucide-react";

/** Small pill shown on Pro features while the user's 7-day trial is active. */
const TrialPill = ({ className = "" }) => {
  const { isTrialing } = useAuth();
  if (!isTrialing) return null;
  return (
    <span
      data-testid="trial-pill"
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary/10 border border-primary/25 text-primary text-xs font-semibold whitespace-nowrap ${className}`}
    >
      <Sparkles className="w-3 h-3" />
      Included in your 7-day Pro trial
    </span>
  );
};

export default TrialPill;
